import type { MenuList } from '../../interface/layout/menu.interface';
import type { FC } from 'react';
import { Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUserItem } from '../../stores/user.store';
import { CustomIcon } from './customIcon';
import { resetTagState } from '../../stores/tags-view.store';

interface MenuProps {
  menuList: MenuList;
  openKey?: string;
  onChangeOpenKey: (key?: string) => void;
  selectedKey: string;
  onChangeSelectedKey: (key: string) => void;
}

const MenuComponent: FC<MenuProps> = (props) => {
  const { menuList, openKey, onChangeOpenKey, selectedKey, onChangeSelectedKey } = props;
  const { device, locale } = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getTitle = (menu: MenuList[0] | any) => {
    return (
      <span style={{ display: 'flex', alignItems: 'center' }}>
        <CustomIcon type={menu.icon!} />
        <span>{menu.label[locale]}</span>
      </span>
    );
  };

  const onMenuClick = (path: string) => {
    onChangeSelectedKey(path);
    dispatch(resetTagState(path));
    navigate(path);

    if (device !== 'DESKTOP') {
      dispatch(setUserItem({ collapsed: true }));
    }
  };

  const onOpenChange = (keys: string[]) => {
    const key = keys.pop();

    onChangeOpenKey(key);
  };

  return (
    <Menu
      mode="inline"
      selectedKeys={[selectedKey]}
      openKeys={openKey ? [openKey] : []}
      onOpenChange={onOpenChange}
      onSelect={(k: any) => onMenuClick(k.key)}
      className="layout-page-sider-menu text-2"
      items={menuList
        .filter((menu: any) => menu.config !== false)
        .map((menu: any) => {
          return menu.children
            ? {
                key: menu.code,
                label: getTitle(menu),
                children: menu.children
                  .filter((child: any) => child.config !== false)
                  .map((child: any) => ({
                    key: child.path,
                    label: child.label[locale],
                  })),
              }
            : {
                key: menu.path,
                label: getTitle(menu),
              };
        })}
    ></Menu>
  );
};

export default MenuComponent;
